module.exports = __webpack_public_path__ + "static/img/66.93f9aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/66.png
// module id = LjPV
// module chunks = 0